'use client';
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// biome-ignore lint/style/useImportType: This is needed!
import React from 'react';
import { useCallback, useEffect, useState } from 'react';
import reactStringReplace from 'react-string-replace';
const defaultHighlighter = (text, key) => (React.createElement("mark", { key: key }, text));
function MatchHighlighter({ children, highlighter, context, }) {
    return (React.createElement(React.Fragment, null, reactStringReplace(children, /\[h\](.+?)\[\/h\]/g, (match, index) => highlighter(match, index.toString(), context))));
}
export function useSiteSearch(config) {
    var _a, _b, _c;
    const [state, setState] = useState({
        query: ((_a = config.initialState) === null || _a === void 0 ? void 0 : _a.query) || '',
        page: ((_b = config.initialState) === null || _b === void 0 ? void 0 : _b.page) || 0,
        locale: (_c = config.initialState) === null || _c === void 0 ? void 0 : _c.locale,
    });
    const [error, setError] = useState();
    const [response, setResponse] = useState();
    const resultsPerPage = config.resultsPerPage || 8;
    useEffect(() => {
        let isCancelled = false;
        const run = () => __awaiter(this, void 0, void 0, function* () {
            try {
                setError(undefined);
                if (!state.query) {
                    setResponse({ data: [], meta: { total_count: 0 } });
                    return;
                }
                setResponse(undefined);
                const request = {
                    filter: {
                        query: state.query,
                        locale: state.locale,
                        build_trigger_id: config.buildTriggerId,
                    },
                    page: {
                        limit: resultsPerPage,
                        offset: resultsPerPage * state.page,
                    },
                };
                if (config.fuzzySearch) {
                    request.fuzzy = 'true';
                }
                const response = yield config.client.searchResults.rawList(request);
                if (!isCancelled) {
                    setResponse(response);
                }
            }
            catch (e) {
                if (isCancelled) {
                    return;
                }
                if (e instanceof Error) {
                    setError(e.message);
                }
                else {
                    setError('Unknown error!');
                }
            }
        });
        run();
        return () => {
            isCancelled = true;
        };
    }, [
        resultsPerPage,
        state,
        config.buildTriggerId,
        config.fuzzySearch,
        config.client.config.apiToken,
    ]);
    const publicSetQuery = useCallback((newQuery) => {
        setState((oldState) => (Object.assign(Object.assign({}, oldState), { query: newQuery, page: 0 })));
    }, [setState]);
    const publicSetPage = useCallback((newPage) => {
        setState((oldState) => (Object.assign(Object.assign({}, oldState), { page: newPage })));
    }, [setState]);
    const publicSetLocale = useCallback((newLocale) => {
        setState((oldState) => (Object.assign(Object.assign({}, oldState), { locale: newLocale, page: 0 })));
    }, [setState]);
    const highlighter = config.highlightMatch || defaultHighlighter;
    return {
        state: {
            query: state.query,
            setQuery: publicSetQuery,
            page: state.page,
            setPage: publicSetPage,
            locale: state.locale,
            setLocale: publicSetLocale,
        },
        error,
        data: state.query === ''
            ? {
                pageResults: [],
                totalResults: 0,
                totalPages: 0,
            }
            : response
                ? {
                    pageResults: response.data.map((rawSearchResult) => ({
                        id: rawSearchResult.id,
                        url: rawSearchResult.attributes.url,
                        title: rawSearchResult.attributes.highlight.title ? (React.createElement(MatchHighlighter, { highlighter: highlighter, context: "title" }, rawSearchResult.attributes.highlight.title[0])) : (rawSearchResult.attributes.title),
                        bodyExcerpt: rawSearchResult.attributes.highlight.body ? (React.createElement(MatchHighlighter, { highlighter: highlighter, context: "bodyExcerpt" }, rawSearchResult.attributes.highlight.body[0])) : (rawSearchResult.attributes.body_excerpt),
                        raw: rawSearchResult,
                    })),
                    totalResults: response.meta.total_count,
                    totalPages: Math.ceil(response.meta.total_count / resultsPerPage),
                }
                : undefined,
    };
}
//# sourceMappingURL=index.js.map